export const CSRF_HEADER = {
  'X-ANTI-CSRF': '1',
};
